module.exports = {"ru":{"zoomInButton":"Увеличить","excelButton":"Загрузить XLS"},"en":{"zoomInButton":"Zoom In","excelButton":"Download XLS"}}